import 'assets/css/components/Button.scss';

type TypeButtonProps = {
  content: string,
  icon?: React.ReactNode,
  onClick: () => void,
  active: boolean
}

const TypeButton = ({ content, icon, onClick, active }: TypeButtonProps): JSX.Element => {
  return (
    <button
      type='button'
      className='button'
      aria-current={ active ? "true" : "false" }
      onClick={ onClick }
    >
      { icon && <>{ icon }</> }
      <span>{ content }</span>
    </button>
  );
};

export default TypeButton;
